import { useTranslation } from '@gimlite/common';
import {
  Timeline,
  TimelineType,
} from '../../components/timeline/timeline.component';

export declare namespace ExitDeniedSessionTimelineType {
  type Props = {
    data: {
      date: TimelineType.Data.Date;
      extra: TimelineType.Data.Extra;
      device: TimelineType.Data.Device;
      subtitle: TimelineType.Data.SubTitle;
    };
  };
}

export const ExitDeniedSessionTimeline = ({
  data: { date, extra, device, subtitle },
}: ExitDeniedSessionTimelineType.Props) => {
  const { t } = useTranslation();
  return (
    <Timeline
      config={{
        color: 'error',
      }}
      data={{
        icon: 'faCarSolid',
        date,
        device,
        title: t('global-state-exit-denied'),
        extra,
        subtitle: t(`global-reason-${subtitle}`),
      }}
    />
  );
};
